import { connect } from 'react-redux'

import Actions from '../../Actions/Creators'
import Resources from './Component/Resources'


const mapStateToProps = (state, ownProps) => {

    return {
        organization: state.organization.currentOrganization 
    };
};


const mapDispatchToProps = (dispatch) => ({
   
})


export default connect(mapStateToProps, mapDispatchToProps)(Resources)